module.exports = __webpack_public_path__ + "static/img/reference pics_forth tunnel1.48cc4e5a.jpg";